import { render, staticRenderFns } from "./PublicContactProject.vue?vue&type=template&id=112d191e&scoped=true&"
import script from "./PublicContactProject.vue?vue&type=script&lang=js&"
export * from "./PublicContactProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112d191e",
  null
  
)

export default component.exports